/**
 * Consent Toggle Component
 * Toggle voor toestemming audio opname en AI verwerking
 */

import React from 'react';
import './ConsentToggle.css';

interface ConsentToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const ConsentToggle: React.FC<ConsentToggleProps> = ({
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="consent-toggle-container">
      <label className="consent-toggle-label">
        <input
          type="checkbox"
          className="consent-toggle-input"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        <span className="consent-toggle-switch"></span>
        <span className="consent-toggle-text">
          Ik geef toestemming om dit gesprek op te nemen en met AI te laten bewerken.
        </span>
      </label>
      {!checked && (
        <small className="consent-hint">
          Vink dit aan voordat je de opname start
        </small>
      )}
    </div>
  );
};